import React from 'react';

/**
 * Shared session page header: session name, optional host line, End Session slot, footer (e.g. tabs).
 * Used by Dashboard (competitive) and SocialSessionPage.
 */
function SessionLayout({
  sessionName = 'Session Dashboard',
  sessionCreator = null,
  endSessionButton = null,
  footer = null,
  className = '',
}) {
  return (
    <div className={`bg-surface shadow-brand-sm rounded-lg px-4 py-3 mb-3 border border-border-medium ${className}`.trim()}>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h1 className="text-xl font-semibold text-text-primary leading-tight">{sessionName}</h1>
          {sessionCreator && (
            <div className="mt-1.5 text-sm text-text-secondary">
              <span className="inline-flex items-center gap-1.5">
                <svg className="h-4 w-4 shrink-0 opacity-80" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                <span>
                  Host: {sessionCreator.first_name} {sessionCreator.last_name}
                </span>
              </span>
            </div>
          )}
        </div>
        <div className="flex flex-col items-end gap-2">
          {endSessionButton != null && (
            <div className="flex space-x-2">{endSessionButton}</div>
          )}
        </div>
      </div>
      {footer && <div className="mt-3 pt-2 border-t border-border-light">{footer}</div>}
    </div>
  );
}

export default SessionLayout;
